<template>
  <div class="gallery-item position-relative">
    <div v-if="!isLoading" class="img">
      <img :src="image.url" alt="">
    </div>
    <div v-if="isLoading" class="text-center">
      <div class="spinner-border spinner-size" role="status">
        <span class="visually-hidden fs-1">{{ $t('key_loading') }}</span>
      </div>
    </div>
    <a style="cursor:pointer" :title="$t('key_delete')" class="remove-item" @click="updateImage(image)">
      <i class="fa-solid fa-window-close"></i>
    </a>
    <a style="cursor:pointer" :title="$t('key_download')" class="download-image-resource" @click="download(image)">
      <i class="fa-solid fa-download"></i>
    </a>
    <div class="img-info">
      <div class="img-name" :title="getImageName(image.name)">{{ getImageName(image.name) }}</div>
      <div class="img-size">{{ $dateUtils.toDDMMYYYYHH(image.date) }}</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "ImageItem",
    props: {
      image: {
        type: Object,
        required: true
      },
      errorRemove: {
        type: Object,
        default: () => {
          return null;
        },
      },
      successRemove: {
        type: Object,
        default: () => {
          return null;
        },
      },
      errorDownload: {
        type: Object,
        default: () => {
          return null;
        },
      },
      successDownload: {
        type: Boolean,
        default: () => {
          return null;
        },
      },
      confirmDelete: {
        type: Boolean,
        default: () => {
          return false;
        },
      },
    },
    emits: ['switch', 'remove', 'download', 'request-remove'],
    data() {
      return {
        isLoading: false,
        currentImage: null
      }
    },
    computed: {},
    watch: {
      image() {
        if (this.image) {
          this.isLoading = false
        }
      },
      errorRemove() {
        if(this.errorRemove) {
          this.isLoading = false
        }
      },
      errorDownload() {
        if(this.errorDownload) {
          this.isLoading = false
        }
      },
      successRemove() {
        if(this.successRemove) {
          this.isLoading = false
        }
      },
      successDownload() {
        if(this.successDownload) {
          this.isLoading = false
        }
      },
      confirmDelete() {
        if(!this.confirmDelete && typeof this.confirmDelete != 'boolean') {
          this.isLoading = false
        }
      },
    },
    methods: {
      updateImage(img) {
        // this.isLoading = true
        this.$emit('request-remove', img)
      },
      remove(img) {
        this.isLoading = true
        this.$emit('remove', img)
      },
      download(value) {
        this.isLoading = true
        this.$emit('download', value)
      },
      getImageName(value) {
        const name = value.split('/')[2]
        return name
      },
    },
  };
  
</script>

<style lang="scss">

  .spinner-size {
    width: 3rem;
    height: 3rem;
  }

  .remove-item {
    display: none;
    cursor: pointer;
    position: absolute;
    top: 0.1rem;
    left: 7.5rem;
    font-size: 1.5rem;
  }

  .download-image-resource {
    display: none;
    cursor: pointer;
    position: absolute;
    top: 0.1rem;
    left: 1rem;
    font-size: 1.5rem;
  }


  $primColor: #F2F3F4;
  $secTextColor: black;

  .gallery {
    //display: flex;
    flex: auto;
    flex-wrap: wrap;
    align-items: center;
    justify-content: left;
    // margin: 0 0 -0.5rem 1.5rem;
    margin-left: .2rem;


    .gallery-new-item {
      height: 176px;
      // width: 180px;
      padding: 0rem;
      margin: 0 0.5rem 1rem 0.5rem;

      overflow: hidden;
      display: inline-table;
      grid-template-rows: 70% 30%;
      align-items: center;
      justify-content: center;

      border-radius: 5px;
    }

    .gallery-item {
      height: 175px;
      width: 154px !important;
      padding: 0rem;
      margin: 0 0.5rem 1rem 0.5rem;

      overflow: hidden;
      display: inline-grid;
      grid-template-rows: 70% 30%;
      align-items: center;
      justify-content: center;

      border-radius: 5px;
      background-size: cover;
      background-color: #F2F3F4;

      .img {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }

      .img-info {
        padding: 0.5rem 0;
        overflow: hidden;
        text-align: center;
        background-color: #F2F3F4;

        .img-name {
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 0.875rem;
          color: black;
          max-width: 190px;
          overflow: hidden;
          padding: 0 0.5rem;
        }

        .img-size {
          font-size: 0.75rem;
          color: black;
          text-align: center;
          padding: 0 1rem;
        }
      }
    }

    .gallery-item:hover .img {
      opacity: 0.5;
    }

    .gallery-item:hover .remove-item {
      display: block;
      color: #4A7062
    }

    .gallery-item:hover .download-image-resource {
      display: block;
      color: #4A7062
    }
  }
  
</style>
